/**
 * 优化特殊样式标签，改为自定义标签
 */
import {IStoryData} from '../../../../service/contentServer';

function emptyTags(str) {
  if (typeof str !== 'string') {
    return '';
  }
  return str.replace(/(<[\/]?)(font|script)([^>]*?>)/g, function(fullstr, str0, str1, str2) {
    return (str0 || '') + ('ui-' + str1) + (str2 || '');
  });
}

function emptyTagsSomeAttr(str) {
  if (typeof str !== 'string') {
    return '';
  }
  // 不删除源站ui属性，前端根据需要使用
  return str.replace(/\s((style|width|height)="[^"]+")/g, function(fullAttrStr, matchAttrStr) {
    if (matchAttrStr) {
      return ' ui-' + matchAttrStr;
    } else {
      return fullAttrStr;
    }
  });
  // return str
}

/**
 * 过滤facebook的相关数据
 *
 * @param  {String} str
 * @return {String}
 */
function filterFacebook(str) {
  if (typeof str !== 'string') {
    return '';
  }
  return str.replace(/(data-width)="[^"]+"/gi, '');
}

/**
 * 合并多个br到一个
 *
 * @param  {String} str
 * @return {String}
 */
function combineMultipleBrToOne(str) {
  if (typeof str !== 'string') {
    return '';
  }
  return str
    .replace(/(<br>)+<p/gi, '<p')
    .replace(/<\/p>(<br>)+/gi, '</p>')
    .replace(/(<br \/>)+<p/gi, '<p')
    .replace(/<\/p>(<br \/>)+/gi, '</p>')
    .replace(/(<br>)+<div/gi, '<div')
    .replace(/(<br \/>)+<div/gi, '<div')
    .replace(/<\/div>(<br>)+/gi, '</div>')
    .replace(/<\/div>(<br \/>)+/gi, '</div>')
    .replace(/(<br \/>)+<res-image/gi, '<res-image')
    // 如果是连续出现3个br，替换成2个
    .replace(/(<br>[\s]*){3,}/gi, '<br><br>');
}

function resVideoRemoveParentP(str: string): string {
  return str.replace(/<p\s*>\s*<res-video\s+([^>]+)>\s*<\/res-video>\s*<\/p>/g,
    '<res-video $1></res-video>');
}

function resImageRemoveParentP(str: string): string {
  return str.replace(/<p\s*>\s*<res-image\s+([^>]+)>\s*<\/res-image>\s*<\/p>/g,
    '<res-image $1></res-image>');
}

const resourceHandler = {
  /* 'image': function (tar) {
       var imgWidth = parseInt(tar.optimalWidth);
       var imgHeight = parseInt(tar.optimalHeight);
       var url = tar.url || '';
       var title = tar.title || '';
       var html = '';
       if (imgWidth <= 1 && imgHeight <= 1) {
           return html;
       }
       html =  '<res-image id="'+tar.id+'" width="'+imgWidth+'" height="'+imgHeight+'"></res-image>';

       return html;
   },*/
  old_image(tar) {
    const imgWidth = parseInt(tar.optimalWidth, 10);
    const imgHeight = parseInt(tar.optimalHeight, 10);
    const url = tar.url || '';
    const title = tar.title || '';
    const html = '';
    if (imgWidth <= 1 && imgHeight <= 1) {
      return html;
    }
    const imageHtml = `<div class="image-widget">
                      <div class="img-container">
                      <img class="img-tar " data-src="${url}" ui-width="${imgWidth}"
                       ui-height="${imgHeight}"   save-src="${tar.originalSaveUrl}" />
                      <div class="tap-to-load-image">
                      </div>
                      </div>
                      <div class="img-title">${title}</div>
                      </div>`;
    /*
    html = '<div class="img">' +
        '<img class="img-tar ' + (imgWidth > 240 ? 'img-l' : '') + '" src="' + url + '" alt="' + title + '" />' +
        '<div class="img-title">' + title + '</div>' +
        '</div>';
*/
    return imageHtml;
  },
  old_video(tar) {
    const playerType = tar.playerType || 'video';
    const url = tar.url || '';
    const title = tar.title || '';
    let html = '';
    let widthHeightRatio = 560 / 315;
    const maxWidth = 560;
    if (tar.oriWidth && tar.oriHeight) {
      widthHeightRatio = tar.oriWidth / tar.oriHeight;
    }
    if (tar.width && tar.height) {
      widthHeightRatio = tar.width / tar.height;
    }
    // &&!/.+\.mp4$/g.test(url)
    if (/iframe/.test(playerType)) {
      html = '<div class="video-frame" wh-ratio="' + widthHeightRatio + '" max-width="' + maxWidth + '" >' +
        '<iframe class="video" src="' + url + '" allowfullscreen></iframe>' +
        '<div class="video-title">' + title + '</div>' +
        '</div>';
    } else if (/(object|embed)/.test(playerType)) {
      html = '<div class="video-frame" wh-ratio="' + widthHeightRatio + '" max-width="' + maxWidth + '">' +
        '<object data="' + url + '" class="video" type="application/x-shockwave-flash">' +
        '<param value="' + url + '" name="movie"/>' +
        '</object>' +
        '<div class="video-title">' + title + '</div>' +
        '</div>';
    } else {
      html = '<div class="video-frame" wh-ratio="' + widthHeightRatio + '" max-width="' + maxWidth + '">' +
        '<video src="' + url + '" class="video" controls></video>' +
        '<div class="video-title">' + title + '</div>' +
        '</div>';
    }
    return html;
  },
  audio(tar) {
    const html = '<div class="audio">' + tar.html + '</div>';
    return html;
  },

};

export function contentParse(story: IStoryData): string {

  let content = story.content || '';

  content = filterFacebook(content);

  content = emptyTags(content);

  content = emptyTagsSomeAttr(content);

  content = combineMultipleBrToOne(content);

  content = resVideoRemoveParentP(content);
  content = resImageRemoveParentP(content);
  // content = filterInstagram(content);

  // 去掉空标签,通过以下黑名单过滤
  const empty = /<(p|table|address|article|aside|blockqoute|pre|h\d|section)(\s([^>]*)>|>)(\s|&nbsp;)*<\/\1>/g;
  while (empty.test(content)) {
    content = content.replace(empty, '');
  }

  return content;

  // const resTags = [];
  // const attrFilter = [];
  //
  // function genResTag(res) {
  //   let tag = '<res ';
  //   for (const key in res) {
  //     if (attrFilter.indexOf(key) == -1) {
  //       let value = '' + res[key];
  //       value = value.replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  //       tag += key.toLocaleLowerCase() + '="' + value + '" ';
  //     }
  //   }
  //   tag += '></res>';
  //
  //   resTags.push(tag);
  // }
  //
  // // story.image && story.image.forEach(genResTag);
  // // story.video && story.video.forEach(genResTag);
  // // story.audio && story.audio.forEach(genResTag);
  // content += resTags.join('');
  //
  // // 内化标签解析
  // // resources
  // const assets = {};
  // story.image && story.image.forEach(function(res) {
  //   assets[res.id] = res;
  // });
  // story.video && story.video.forEach(function(res) {
  //   assets[res.id] = res;
  // });
  // story.audio && story.audio.forEach(function(res) {
  //   assets[res.id] = res;
  // });
  //
  // // 匹配内化标签
  // const labels = content.match(/(<res\-\w+ id="\w+?"><\/res\-\w+>)|(<res\-\w+ id="\w+?"\/>)/g);
  // labels && labels.forEach(function(res) {
  //   const id = res.match(/id="(\w+)"/)[1];
  //   const type = res.match(/res\-(\w+)/)[1];
  //   const tar = assets[id];
  //
  //   if (tar) {
  //     let html = res;
  //     if (resourceHandler.hasOwnProperty(type)) {
  //       html = resourceHandler[type](tar);
  //     }
  //
  //     content = content.replace(res, html);
  //   }
  // });
  //
  // const galleryLabels = content.match(/(<res\-gallery ids=".+"><\/res\-gallery>)|(<res\-gallery ids=".+"\/>)/g);
  //
  // galleryLabels && galleryLabels.forEach(function(res) {
  //   const ids = res.match(/ids="(.+)"/)[1].split(',');
  //   let html = '';
  //   ids.forEach(function(id) {
  //     const tar = assets[id];
  //
  //     if (!tar) { return; }
  //
  //     const url = tar.url;
  //     const title = tar.title || '';
  //     const imgWidth = parseInt(tar.optimalWidth, 10);
  //     html += `<div class="img"><img class="img-tar ${imgWidth > 240 ? 'img-l' : ''}" src="${url}" alt="${title}" />
  //             <div class="img-title">${title}</div></div>`;
  //   });
  //
  //   content = content.replace(res, html);
  // });
  //
  // return content;
}
